import { render, staticRenderFns } from "./PlatformVersionTable.vue?vue&type=template&id=17975719&"
import script from "./PlatformVersionTable.vue?vue&type=script&lang=js&"
export * from "./PlatformVersionTable.vue?vue&type=script&lang=js&"
import style0 from "./PlatformVersionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports